import Link from "next/link";
import { CONTACT } from "@/lib/data";
import { Magnetic } from "../Magnetic";
import { Reveal } from "../Reveal";

export function Cta() {
  return (
    <section className="bg-brass px-5 py-24 text-ink md:px-8 md:py-32">
      <Reveal>
        <div className="mx-auto max-w-7xl">
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase">Ostwald · Quai Olida</p>
          <h2 className="font-display mt-4 max-w-4xl text-4xl leading-[0.92] md:text-7xl">
            Passez au stand.
            <br />
            On vous remet en ligne.
          </h2>
          <div className="mt-10 flex flex-wrap gap-4">
            <Magnetic>
              <Link
                href="/contact"
                className="inline-flex rounded-sm bg-ink px-7 py-3.5 text-xs tracking-[0.18em] text-paper uppercase"
              >
                Prendre contact
              </Link>
            </Magnetic>
            <a href={CONTACT.phoneHref} className="inline-flex items-center text-sm underline underline-offset-4">
              {CONTACT.phone}
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
